const featureItems = [
  {
    title: '海量资源 · 应有尽有',
    desc: '糖心影视平台聚合全网高清影视资源，覆盖最新电影、热播电视剧、人气综艺、经典动漫、高分纪录片等全品类。无论你喜欢什么类型，在这里都能找到。每日持续更新，紧跟全网热点，让你不错过任何一部好片。',
    icon: 'ri-database-2-line',
    color: 'bg-primary-100 text-primary-600',
  },
  {
    title: '即点即播 · 无需等待',
    desc: '打开糖心影视网站即可在线观看，无需注册账号，无需下载任何软件或插件。先进的播放技术确保高清画质下的流畅体验，低网速环境下依然稳定播放。支持断点续播，随时继续上次的观影进度。',
    icon: 'ri-flashlight-line',
    color: 'bg-accent-100 text-accent-600',
  },
  {
    title: '多端适配 · 随心观影',
    desc: '糖心影视完美适配电脑、平板和手机浏览器，无论你使用Windows、macOS、iOS还是Android设备，都能获得一致的优质观影体验。自适应布局让屏幕空间得到最大化利用，随时随地畅享观影乐趣。',
    icon: 'ri-device-line',
    color: 'bg-secondary-100 text-secondary-600',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            平台优势
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            为什么选择糖心影视？三大核心优势，让观影成为一种甜蜜享受
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {featureItems.map((item) => (
            <div
              key={item.title}
              className="group p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-200/40 transition-all text-center"
            >
              <span className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl ${item.color} mx-auto mb-5 group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} text-2xl md:text-3xl`}></i>
              </span>
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}